'use client'
import { designGrid, mq, presets } from '@/styles'
import styled from 'styled-components'

export const MainGrid = styled.main`
  ${designGrid({})}
	margin-bottom: 70px;

  ${mq.greaterThan('container')} {
    margin: 0 auto 100px;
    max-width: var(--page-container-max-width);
  }

  form {
    grid-column: 1 / span 6;
    margin-bottom: 60px;

    ${mq.greaterThan('tablet')} {
      grid-column: 5 / span 5;
      margin-bottom: 0;
    }
  }

  > article {

    ~ section {
      ${mq.greaterThan('tablet')} {
        grid-row: 2 / span 1;
      }
    }

    + section {
      ${mq.greaterThan('tablet')} {
        grid-row: 2 / span 2;
      }
    }
  }
`

export const MainStyled= styled.main`
	min-height: 600px;
  width: 100vw;
  width: 100dvw;

  ${mq.greaterThan('container')} {
    margin: 0 auto;
    max-width: var(--page-container-max-width);
  }
`

export const MainCart = styled.main`
  ${designGrid({ })}
  flex-grow: 2;
  margin-bottom: 70px;

  ${mq.greaterThan('container')} {
    margin: 0 auto 70px;
    max-width: var(--page-container-max-width);
  }

  hgroup {
    grid-column: 1 / span 6;

    ${mq.greaterThan('tablet')} {
      grid-column: 3 / span 7;
    }

    h2 {
      margin-bottom: 20px;
    }

    h2, p {
      text-align: center;
    }
  }

  .relateds {
    display:none;

    ${mq.greaterThan('tablet')} {
      display:grid;
      grid-column: 2/ 12;
      margin-top: 80px;
    }

    section dt:first-of-type {
      margin:0;
    }

    h2 {
      ${mq.greaterThan('tablet')} {
        ${presets.font30}
        color: var(--color-text--yellow);
        text-align: left;
        margin-bottom: 22px;
      }
    }
  }
`
